var e = {
  BUTTON: {
    eventName: "ford-credit-global-onclick",
    dataElement: "onclick"
  },
  MODAL: {
    eventName: "global-modal-view",
    dataElement: "modal"
  }
};
export {
  e as ComponentAnalyticsDefinitions
};
